module.exports = __webpack_public_path__ + "img/kseniya-petukhova-_wj5Jd-AaK4-unsplash.b1d69d5c.jpg";